import script from "./TableFull.vue?vue&type=script&setup=true&lang=js"
export * from "./TableFull.vue?vue&type=script&setup=true&lang=js"

import "./TableFull.vue?vue&type=style&index=0&id=53997bb4&lang=css"

const __exports__ = script;

export default __exports__